var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-environment-sticker",class:{
        'v-environment-sticker__bottomRight': _vm.position === 'BOTTOM_RIGHT',
        'v-environment-sticker__bottomLeft': _vm.position === 'BOTTOM_LEFT'
    }},[(_vm.theme === 'SQUARE')?_c('square-theme',{attrs:{"label":_vm.label,"container-styles":_vm.containerStyles,"label-styles":_vm.labelStyles}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }